import { Box, Button, ButtonGroup, Divider, HorizontalGrid, HorizontalStack, Text } from '@shopify/polaris';
import FilterSelect from '../Products/FilterSelect';
import DropdownFilter from '../Common/DropdownFilter';
import DateRangePicker from '../Common/DateRangePicker';

const FiltersLikeSells = ({ filters, handleDateChange, handleFilter, defaultDates, clearFilters, omitFilters }) => {
  const omitDeposits = (omitFilters ?? []).includes('deposits');

  return (
    <>
      <HorizontalGrid columns={{ xs: 1, md: '4fr 3fr' }} gap="4">
        <HorizontalStack align="start" gap={4}>
          <Box>
            <Text variant="headingMd" as="h4">
              Fechas
            </Text>
            <Box border="divider" borderRadius="base" minHeight=".5rem" />
            <DateRangePicker onDateChanges={handleDateChange} defaultDates={defaultDates} />
          </Box>
          {!omitDeposits && (
            <Box>
              <Text variant="headingMd" as="h4">
                Depósitos
              </Text>
              <Box border="divider" borderRadius="base" minHeight=".5rem" />
              <DropdownFilter
                slug="deposits"
                title="Depósitos"
                onFilterChange={handleFilter}
                defaultValue={filters.deposits?.value ?? ''}
                options={filters.deposits?.options ?? []}
              />
            </Box>
          )}
        </HorizontalStack>
        {/* <Box>
                    <Text variant="headingMd" as="h4">
                      Clientes
                    </Text>
                    <Box border="divider" borderRadius="base" minHeight=".5rem" />
                    <DropdownFilter
                      slug="customers"
                      title="Clientes"
                      onFilterChange={handleFilter}
                      defaultValue={filters.customers?.value ?? ''}
                      options={filters.customers?.options ?? []}
                    />
                  </Box> */}
        <HorizontalStack align="end">
          <Box>
            <Text variant="headingMd" as="h4">
              Categorización
            </Text>
            <Box border="divider" borderRadius="base" minHeight=".5rem" />
            <ButtonGroup segmented>
              {Object.keys(filters)
                .map((k) => filters[k])
                .filter((f) => f.bundle)
                .map(
                  (filter) =>
                    filter && (
                      <FilterSelect
                        {...filter}
                        options={filter.options ?? []}
                        key={filter.slug}
                        defaultValue={filter.value ?? ''}
                        onFilterChange={handleFilter}
                      />
                    ),
                )}
            </ButtonGroup>
          </Box>
        </HorizontalStack>
      </HorizontalGrid>
      <Box minHeight=".5rem" />
      <Divider />
      <Box minHeight=".5rem" />
      <HorizontalStack align="end">
        <Button onClick={clearFilters} plain>
          Borrar filtros
        </Button>
      </HorizontalStack>
    </>
  );
};

export default FiltersLikeSells;
